<template>
  <div>
    <div class="main-button-bar">
      <el-button type="primary" size="small" @click="showAddDialog">新增支出类型</el-button>
    </div>

    <el-table
      :data="records"
      stripe
      style="width: 100%"
      :height="this.$tools.mainHeight() - 84"
      class="finance-expense-table"
    >
      <el-table-column prop="name" label="支出类型名称" width="200"></el-table-column>
      <el-table-column prop="status" label="状态" width="100">
        <template slot-scope="expendType">
          <el-tag type="success" v-if="expendType.row.status == 'Y'">可用</el-tag>
          <el-tag type="danger" v-if="expendType.row.status == 'N'">禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="expendType">
          <el-button v-if="expendType.row.status == 'Y'" type="text" size="small" v-on:click="upstatus(expendType.row.id, 'N')">禁用</el-button>
          <el-button v-if="expendType.row.status == 'N' || !expendType.row.status" type="text" size="small" v-on:click="upstatus(expendType.row.id, 'Y')">启用</el-button>
          <el-button type="text" size="small" v-on:click="upname(expendType.row.id)">修改名称</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="expendType && expendType.id ? '修改渠道' : '新增渠道'" :visible.sync="showDialog" width="500px">
      <el-form ref="expendType" :model="expendType" label-width="60px" :rules="rules">
        <el-form-item label="名称" prop="name">
          <el-input v-model="expendType.name"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" class="op-button" @click="doAdd">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showDialog: false,
      records: null,
      expendType: {},
      rules: {
        name: [
          { required: true, message: "请输入名称", trigger: "blur" },
          {
            min: 2,
            max: 10,
            message: "长度在 2 到 6 个字符",
            trigger: "blur",
          },
        ]
      },
    };
  },
  methods: {
    showAddDialog() {
      this.expendType = {};
      this.showDialog = true;
    },
    doAdd() {
      let _this = this;

      _this.$http.post(
        ["finance/expense/type/save", _this.expendType],
        [
          function () {
            _this.showDialog = false;
            _this.expendType = {};
            _this.list();
          },
        ],
        ".op-button"
      );
    },

    list() {
      let _this = this;

      _this.$http.post(
        ["finance/expense/type/all"],
        [
          function (data) {
            _this.records = data;
          },
        ],
        ".finance-expense-table"
      );
    },

    upstatus(id, status) {
      this.expendType.id = id;
      this.expendType.status = status;
      this.doAdd();
    },

    upname(id) {
      let _this = this;

      _this.$tPrompt.show("输入新名称", function(data) {
        _this.expendType.id = id;
        _this.expendType.name = data;
        _this.doAdd();
      })
    }
  },
  mounted() {
    this.list();
  },
};
</script>

<style lang="scss">
</style>